import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

export default function CustomersBanner(props) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const customersList = [
    "UNICEF",
    "KCMC Hospital",
    "Dodoma Referral Hospital",
    "Lugalo Hospital",
    "Lupita MT",
    "Mnazi Mmoja Hospital",
    "Bochi Hospital",
    "E.M Hospital",
    "Qualitus Hospital",
    "Vijibweni Hospital",
    "Katavi Referal Hospital",
    "Mwananyamala Hospital",
    "Temeke Hospital",
    "Muhimbili Hospital"
  ];

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">{getInlineLoader()}</div>
    );
  }

  return (
    <div className="MainBodySection bg-surface" style={{ paddingTop: "40px", paddingBottom: "40px" }}>
      <div className="container">
        <div className="row">
          <div className="col-md-12 mb-4">
            <h6 className="main-section-title mb-2">
              Our Customers
              <span
                style={{
                  display: "block",
                  borderBottom: "3px solid var(--secondaryColor)",
                  width: "50px",
                  marginTop: "10px",
                }}
              ></span>
            </h6>
          </div>

          {customersList.map((cust, i) => (
            <div key={i} className="col-md-3 col-6 mb-3">
              <div className="customer-tile text-center">
                <div
                  className="customer-symbol mx-auto mb-2 d-flex align-items-center justify-content-center"
                  style={{
                    width: "55px",
                    height: "55px",
                    borderRadius: "6px",
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#fff",
                    background: `linear-gradient(135deg, hsl(${(i * 30) % 360}, 60%, 55%), hsl(${(i * 30 + 60) % 360}, 65%, 60%))`,
                  }}
                >
                  {cust.charAt(0).toUpperCase()}
                </div>
                <div className="fw-medium small font-bold text-muted">{cust}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .customer-tile {
          background: #fff;
          border: 1px solid rgba(0, 0, 0, 0.08);
          border-radius: 8px;
          padding: 10px 5px;
          transition: all 0.3s ease;
        }

        .customer-tile:hover {
          border-color: var(--secondaryColor);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          transform: translateY(-3px);
        }

        .customer-symbol {
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        @media (max-width: 768px) {
          .customer-tile { padding: 8px 3px; }
          .customer-symbol { width: 50px; height: 50px; font-size: 14px; }
        }

        @media (prefers-reduced-motion: reduce) {
          .customer-tile:hover { transform: none; box-shadow: none; }
        }
      `}</style>
    </div>
  );
}